<template>
  <ClientOnly v-if="showBanner">
    <div class="war-room-mobile-app-banner-top">
      <CloseIcon class="war-room-mobile-app-banner-top__close" @click="handleClose" />
      <a
        :href="link"
        class="war-room-mobile-app-banner-top__link"
        target="_blank"
        rel="nofollow noopener noreferrer"
        @click="sendEvent"
      >
        Check out our mobile app
        <img
          class="war-room-mobile-app-banner-top__app-store"
          src="./../images/appstore.png"
          width="100"
          alt="Download on the App Store"
        />
      </a>
    </div>
  </ClientOnly>
</template>

<script lang="ts">
import { defineComponent } from '@nuxtjs/composition-api';
import mobileAppBannerMixin from '@/components/partials/war-room/WarRoomMobileAppBanner/mobileAppBannerMixin';
import { invalidRoutes } from '@/components/partials/war-room/WarRoomMobileAppBanner/constants';

const TOOLTIP_NAME = 'mobile-app-banner-top';

export default defineComponent({
  name: 'WarRoomMobileAppBannerTop',
  mixins: [mobileAppBannerMixin(TOOLTIP_NAME)],
  computed: {
    isValidRoute() {
      return !invalidRoutes.some(page => page.name === this.$route.name);
    },

    showBanner() {
      return [this.isVisible, this.$device.isMobile, this.$device.isIos, this.isValidRoute].every(Boolean);
    },
  },
});
</script>

<style lang="scss" scoped>
.war-room-mobile-app-banner-top {
  @include body-semibold;

  position: relative;

  @include mq('sm') {
    display: none;
  }

  &__close {
    position: absolute;
    right: 8px;
    top: 8px;
    width: 24px;
    height: 24px;
    color: var(--gray-50);
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: var(--gray-35);
    }
  }

  &__link {
    display: block;
    padding: 18px calc(100% - 120px - 24px) 24px 24px;
    color: rgba(var(--white));
    text-align: center;
    background-image: url('./images/phones.png');
    background-color: rgba(var(--black));
    background-repeat: no-repeat;
    background-size: calc(100% - 120px) auto;
    background-position: 120px 0;

    @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
      background-image: url('./images/phones@2x.png');
    }
  }

  &__app-store {
    display: block;
    width: 100px;
    height: auto;
    margin: 14px auto 0 auto;
  }
}
</style>
